import type { CollaboratorsRepositoryT } from "shared/domain/ports/collaborators.repository";
import type {
  CollaboratorsApiT,
  CollaboratorsMapperT,
} from "../types/collaborators.types";

import { extractErrorMessage } from "../../../utils/extractErrorMessage";

type CollaboratorsRepositoryParamsT = {
  collaboratorsApi: CollaboratorsApiT;
  collaboratorsMapper: CollaboratorsMapperT;
};

export const createCollaboratorsRepository = ({
  collaboratorsApi,
  collaboratorsMapper,
}: CollaboratorsRepositoryParamsT): CollaboratorsRepositoryT => ({
  getAll: async () => {
    try {
      const response = await collaboratorsApi.getAll();

      if (response.status !== 200) {
        throw new Error("Ocurrió un error al obtener los colaboradores");
      }

      return collaboratorsMapper.collaboratorsDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al obtener los colaboradores",
      );

      throw new Error(message);
    }
  },
});
